<template>
  <a-card style="margin-left: 24px;" class="order-details-page">
    <template slot="title">
      <div class="order-details-title">
        <div>{{ $t('orderCode') }}：{{ orderForm.SHEET_CODE }}</div>
<!--        <div>状态：{{ orderForm.OPER_STATUS }}</div>-->
      </div>
    </template>
    <a-descriptions :column="4" class="order-details-descriptions">
      <template slot="title">
        <div class="order-details-info">{{ $dt(orderForm,'COMPANY_NAME') }}</div>
      </template>
      <a-descriptions-item>
        <template slot="label">
          <span>生成时间</span>
        </template>
        <span>{{ this.$moment(orderForm.CREATE_DATE).format('YYYY-MM-DD') }}</span>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label">
          <span>{{ $t('takeBoxPlace') }}</span>
        </template>
        <span>{{ orderForm.D_CITY_NAME }}</span>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label">
          <span>{{ $t('goodsType') }}</span>
        </template>
        <span>{{ orderForm.GOODS_TYPE_NAME }}</span>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label">
          <span>{{ $t('goodsName') }}</span>
        </template>
        <span>{{ orderForm.GOODS_NAME }}</span>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label">
          <span>{{ $t('takeBoxPlace') }}</span>
        </template>
        <span>{{ orderForm.CITY_NAME }}</span>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label">
          <span>{{ $t('expectedDateOfContainerUse') }}</span>
        </template>
        <span>{{ this.$moment(orderForm.ESTIM_DATE).format('YYYY-MM-DD') }}</span>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label">
          <span>{{ $t('通用_箱型') }}</span>
        </template>
        <span>{{ orderForm.BOX_SIZE_NAME }}</span>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label">
          <span>{{ $t('通用_箱量') }}</span>
        </template>
        <span>{{ orderForm.SHEET_QTY }}</span>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label">
          <span>{{ $t('boxWeight') }}</span>
        </template>
        <span>{{ orderForm.UNIT_WEIGHT || 0 }}{{ $t('ton') }}</span>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label">
          <span>{{ $t('useBoxDay') }}</span>
        </template>
        <span>{{ orderForm.USE_DAYS || 0 }}{{ $t('day') }}</span>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label">
          <span>{{ $t('payStatus') }}</span>
        </template>
        <span>{{ orderForm.ACCT_STATUS === 1 ?  $t('notPaid'):$t('paid') }}</span>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label">
          <span>{{ $t('通用_备注') }}</span>
        </template>
        <span>{{ orderForm.MEMO || '- -' }}</span>
      </a-descriptions-item>
    </a-descriptions>
    <dol-list
      class="dol-list-style"
      title="报价明细"
      :columns="columns"
      :pagination="false"
      source="local"
      :defaultData="priceList"
      :row-key="'FLOW_ID'"
      ref="list"
    >
      <template #extra>
      </template>
    </dol-list>
    <dol-list
      class="dol-list-style"
      title="提箱单明细"
      :columns="takesColumns"
      :pagination="false"
      source="local"
      :defaultData="reBoxOrderList"
      :row-key="'FLOW_ID'"
      ref="list"
    >
      <template #extra>
        <a-button type="primary">批量下载提箱单</a-button>
      </template>
      <template #operation="field, record">
        <a-space>
          <a @click="takesShow=true">{{ $t('confirmTakeBox') }}</a>
          <a @click="openDeferModal(record)">{{ $t('postpone') }}</a>
          <a>下载</a>
        </a-space>
      </template>
    </dol-list>
    <a-card class="takes-detail" :body-style="{padding:'10px 24px'}">
      <template slot="title">
        <div class="takes-detail-title">
          <div>{{ $t('transportInfo') }}</div>
          <a-button @click="transportShow=true">{{ $t('addTransportInformation') }}</a-button>
        </div>
      </template>
      <div class="takes-detail-content" v-if="transportList.length > 0">
        <div v-for="item in transportList" class="takes-detail-content-box">
          <div class="takes-detail-content-box-title">
            <div>{{ $t('transportationType') }}：海铁联运</div>
            <div>
              <a-space>
                <dol-button title="删除"><a-icon type="search" /></dol-button>
                <dol-button :title="$t('edit')" @click="editTransport(item)"><a-icon type="edit" /></dol-button>
              </a-space>
            </div>
          </div>
          <div class="takes-detail-content-box-info">
            <div>海运提单：23283902</div>
            <div style="margin-left: 34px">船名航次：远洋039</div>
          </div>
          <div class="takes-detail-content-box-num">
            {{ $t('通用_箱号') }}（数量3）：
          </div>
          <div class="takes-detail-content-box-code">
             <div v-for="item in 3" style="margin: 6px 15px">23283902</div>
          </div>
        </div>
      </div>
    </a-card>
<!--    <dol-list
        class="dol-list-style"
        title="还箱申请列表"
        :columns="takesApplyColumns"
        :dot-net-table-name="tableName"
        :dot-net-columns="false"
        :row-key="primaryKey"
        :pagination="false"
        ref="list"
    >
      <template #extra>
&lt;!&ndash;        <a-button type="primary"@click="applyShow=true">
          <a-icon type="plus"/>
          创建放箱单
        </a-button>&ndash;&gt;
      </template>
    </dol-list>
    <dol-list
        class="dol-list-style"
        title="还箱指令列表"
        :columns="returnInstructColumns"
        :dot-net-table-name="tableName"
        :dot-net-columns="false"
        :row-key="primaryKey"
        :pagination="false"
        ref="list"
    >
      <template #extra>
      </template>
    </dol-list>
    <dol-list
        class="dol-list-style"
        title="箱子列表"
        :columns="boxColumns"
        :dot-net-table-name="tableName"
        :dot-net-columns="false"
        :row-key="primaryKey"
        :pagination="false"
        ref="list"
    >
      <template #extra>
      </template>
    </dol-list>-->
    <a-modal v-model.trim="takesShow" :centered="true" width="962px" title="确认提箱单" destroyOnClose @ok="addBox"
             @cancel="cancelBox">
      <a-descriptions :column="3">
        <a-descriptions-item>
          <template slot="label">
            <span>{{ $t('takeBoxNumber') }}</span>
          </template>
          <span>2832032434</span>
        </a-descriptions-item>
        <a-descriptions-item>
          <template slot="label">
            <span>{{ $t('takeBoxPlace') }}</span>
          </template>
          <span>上海</span>
        </a-descriptions-item>
        <a-descriptions-item>
          <template slot="label">
            <span>{{ $t('takeBoxIndate') }}</span>
          </template>
          <span>2022-02-02~2022-03-03</span>
        </a-descriptions-item>
        <a-descriptions-item>
          <template slot="label">
            <span>{{ $t('takeBoxCyName') }}</span>
          </template>
          <span>XXXX</span>
        </a-descriptions-item>
        <a-descriptions-item>
          <template slot="label">
            <span>{{ $t('通用_箱型') }}</span>
          </template>
          <span>20GP</span>
        </a-descriptions-item>
        <a-descriptions-item>
          <template slot="label">
            <span>{{ $t('通用_箱量') }}</span>
          </template>
          <span>2</span>
        </a-descriptions-item>
        <a-descriptions-item>
          <template slot="label">
            <span>{{ $t('takeBoxCyAddress') }}</span>
          </template>
          <span>XXXX</span>
        </a-descriptions-item>
        <a-descriptions-item>
          <template slot="label">
            <span>{{ $t('containerYardPhone') }}</span>
          </template>
          <span>12729392379</span>
        </a-descriptions-item>
        <a-descriptions-item>
          <template slot="label">
            <span>提箱免用箱期</span>
          </template>
          <span>7</span>
        </a-descriptions-item>
        <a-descriptions-item :span="3">
          <template slot="label">
            <span>{{ $t('通用_备注') }}</span>
          </template>
          <span>放箱请检查箱子并拍摄箱子四面、关门、开门、箱底及铭牌照片。箱子已经提离堆场，则视为箱子完好。</span>
        </a-descriptions-item>
      </a-descriptions>
      <div style="display: flex;flex-wrap: wrap;">
        <div v-for="item in 3" class="takes-box-div">
          <div style="display: flex">{{ $t('通用_箱号') }}：
            <a-input style="width: 80%"/>
          </div>
          <div style="display: flex;margin-top: 24px"><span>照片：</span>
            <dol-upload-img style="width: 80%"/>
          </div>
        </div>
      </div>
      <a-descriptions :column="3" style="margin-top: 24px">
        <a-descriptions-item>
          <template slot="label">
            <span>{{ $t('driverName') }}</span>
          </template>
          <input/>
        </a-descriptions-item>
        <a-descriptions-item>
          <template slot="label">
            <span>{{ $t('contactWay') }}</span>
          </template>
          <input/>
        </a-descriptions-item>
        <a-descriptions-item>
          <template slot="label">
            <span>{{ $t('licensePlate') }}</span>
          </template>
          <input/>
        </a-descriptions-item>
      </a-descriptions>
    </a-modal>
    <a-modal v-model.trim="transportShow" centered width="900px" :title="$t('addTransportInformation')" destroyOnClose @ok="addOrder"
             @cancel="cancelOrder">
      <dol-form-model :model="boxForm" :rules="boxValidateRules" ref="boxForm">
        <a-row>
          <a-col :span="11">
            <a-form-model-item :label="$t('transportationType')" :labelCol="{span: 5}" :wrapperCol="{span: 19}"   prop="SHIP_TYPE">
            <a-radio-group v-model.trim="boxForm.SHIP_TYPE">
              <a-radio :value="0">
                海铁联运
              </a-radio>
              <a-radio :value="1">
                中俄班列
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="海运提单" :labelCol="{span: 5}" :wrapperCol="{span: 19}"   prop="SHIP_CODE">
              <a-input v-model.trim="boxForm.SHIP_CODE" />
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="船名航次" :labelCol="{span: 5}" :wrapperCol="{span: 19}"   prop="SHIP_NAME">
              <a-input v-model.trim="boxForm.SHIP_NAME" />
            </a-form-model-item>
          </a-col>
        </a-row>
<!--        <a-card class="box-code-card">
          <div>请选择箱号（可多选）：</div>
          <a-checkbox-group v-model.trim="boxForm.BOX_ID" style="margin-top: 16px"  :options="boxOptions" />
        </a-card>-->
      </dol-form-model>
    </a-modal>
    <a-modal v-model.trim="applyShow" centered width="900px" title="上传还箱指令" destroyOnClose @ok="addOrder"
             @cancel="cancelOrder">
      <dol-form-model :model="boxForm" :rules="boxValidateRules" ref="boxForm">
        <a-row>
          <a-col :span="11" >
            <a-form-model-item :label="$t('takeBoxPlace')"  prop="ALREADY_BOX">
              <a-input />
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item :label="$t('returnBoxTime')"  prop="ALREADY_BOX">
              <a-range-picker  />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-card class="box-code-card">
          <div>{{ $t('pleaseSelectTheCaseNumber') }}</div>
          <a-checkbox-group style="margin-top: 16px"  :options="boxOptions" />
        </a-card>
      </dol-form-model>
    </a-modal>

    <a-modal v-model.trim="deferVisible" width="50%" :title="$t('extensionRequest')" destroyOnClose @ok="deferOrder"
             @cancel="cancelDefer">
      <dol-form-model :model="deferForm" :rules="deferValidateRules" ref="deferForm">
        <a-row>
          <a-col :span="11">
            <a-form-model-item :labelCol="{span: 6}" :wrapperCol="{span: 18}" :label="$t('postponeBoxNum')" prop="DELAY_QTY">
              <a-input v-model.trim="deferForm.DELAY_QTY"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item :labelCol="{span: 6}" :wrapperCol="{span: 18}" :label="$t('extensionDate')" prop="DELAY_END_DATE">
              <a-date-picker  :placeholder="$t('pleaseSelectADate')" v-model.trim="deferForm.DELAY_END_DATE" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item :labelCol="{span: 6}" :wrapperCol="{span: 18}" :label="$t('delayReason')" prop="DELAY_DESC">
              <a-input v-model.trim="deferForm.DELAY_DESC"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </dol-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: "indentDetail",
  data() {
    return {
      tableName: 'OT_BOX_SEND_DETAIL',
      primaryKey: 'FLOW_ID',
      takesShow: false,
      transportShow: false,
      deferVisible: false,
      applyShow:false,
      boxForm: {},
      orderForm: {},
      transportList: [],
      boxValidateRules: {
        SHIP_TYPE: [{ required: true, message: this.$t('pleaseSelectAShippingType'), trigger: 'blur' }],
        SHIP_CODE: [{ required: true, message: this.$t('pleaseFillInTheShippingNumber'), trigger: 'blur' }],
        SHIP_NAME: [{ required: true, message: this.$t('pleaseFillInTheNumberOfTransportation'), trigger: 'blur' }],
        BOX_ID: [{ required: true, message: this.$t('pleaseSelectTheShippingBox'), trigger: 'blur' }],
      },
      boxOptions: [],
      priceList: [],
      reBoxOrderList: [],
      deferForm: {},
      deferValidateRules: {
        DELAY_QTY: [
          { required: true, message: this.$t('pleaseFillInTheNumberOfDelayedBoxes'), trigger: ['blur','change'] },
          {
            validator: (rule, value, callback) => {
              if (value > (this.orderData.REAL_QTY - this.orderData.ORDER_QTY - this.orderData.TERM_QTY)) {
                callback(this.$t('extensionBoxIsOver'))
              } else {
                callback()
              }
            }
          }
        ],
        DELAY_END_DATE: [{ required: true, message: this.$t('pleaseFillInTheExtensionDate'), trigger: ['blur','change'] }],
      }
    }
  },
  computed: {
    columns() {
      let columns = [];
      /*columns.push({dataIndex: 'CITY_NAME', title: '放箱地'});
      columns.push({dataIndex: 'D_CITY_NAME', title: '放箱地'});*/
      columns.push({dataIndex: 'BOX_SIZE_NAME', title: this.$t('通用_箱型')});
      columns.push({dataIndex: 'REAL_QTY', title: this.$t('通用_箱量')});
      columns.push({dataIndex: 'BOX_STATE_NAME', title: this.$t('boxStatus')});
      columns.push({dataIndex: 'VALID_PRICE', title: '单价'});
      columns.push({dataIndex: 'SHEET_AMT', title: '小计'});
      columns.push({dataIndex: 'MEMO', title: this.$t('通用_备注')});
      /*columns.push({dataIndex: '_id', width: '40px', scopedSlots: {customRender: 'operation'}});*/

      return columns;
    },
    takesColumns() {
      let columns = [];
      columns.push({dataIndex: 'SHEET_CODE', title: '提箱单号'});
      columns.push({dataIndex: this.$kt('SPACE_NAME'), title: this.$t('通用_堆场')});
      columns.push({dataIndex: 'BOX_SIZE_NAME', title: this.$t('通用_箱型')});
      columns.push({dataIndex: 'SHEET_QTY', title: this.$t('通用_箱量')});
      columns.push({dataIndex: 'CHECK_STATUS', title: this.$t('status')});
      columns.push({dataIndex: '_id', title: this.$t('operate'), scopedSlots: {customRender: 'operation'}});

      return columns;
    },
    takesApplyColumns() {
      let columns = [];
      columns.push({dataIndex: 'MASTER_ID', title: '还箱单号'});
      columns.push({dataIndex: 'D_CITY_ID', title: this.$t('takeBoxPlace')});
      columns.push({dataIndex: 'BEGIN_DATE', title: this.$t('planReturnBoxTime')});
      columns.push({dataIndex: 'BOX_SIZE_NAME', title: this.$t('通用_箱型')});
      columns.push({dataIndex: 'SHEET_QTY', title: this.$('boxNum')});
      columns.push({dataIndex: '_id', title: this.$t('operate'), width: '40px', scopedSlots: {customRender: 'operation'}});
      return columns;
    },
    returnInstructColumns() {
      let columns = [];
      columns.push({dataIndex: 'MASTER_ID', title: '编号'});
      columns.push({dataIndex: 'STATUS', title: this.$t('通用_堆场')});
      columns.push({dataIndex: 'BEGIN_DATE', title: '还箱有效时间'});
      columns.push({dataIndex: 'SHEET_QTY', title: this.$t('通用_箱量')});
      columns.push({dataIndex: '_id', title: this.$t('operate'), width: '40px', scopedSlots: {customRender: 'operation'}});
      return columns;
    },
    boxColumns() {
      let columns = [];
      columns.push({dataIndex: 'MASTER_ID', title: this.$t('通用_箱号')});
      columns.push({dataIndex: 'BOX_SIZE_NAME', title: this.$t('通用_箱型')});
      columns.push({dataIndex: 'BEGIN_DATE', title: this.$t('returnBoxTime')});
      columns.push({dataIndex: 'STATUS', title: this.$t('status')});
      columns.push({dataIndex: '_id', title: this.$t('operate'), width: '40px', scopedSlots: {customRender: 'operation'}});
      return columns;
    }
  },
  methods: {
    disabledDate(current) {
      return current && current <= this.$moment(this.orderData.ESTIM_DATE).startOf('day');
    },
    openDeferModal(data){
      this.deferVisible = true;
      this.orderData = data;
    },
    cancelDefer(){
      this.orderData = {};
      this.deferVisible = false;
    },
    deferOrder(){
      this.$refs.deferForm.validate(val =>{
        if(val){
          let condition = {
            "MASTER_ID": this.orderData.MASTER_ID,
            "FLOW_ID": this.orderData.FLOW_ID,
            "OPER_TYPE": 0,
            ...this.deferForm
          };
          this.$h5Api({
            type:'4020',
            data: [condition],
          }).then(({data}) =>{
            this.$message.info("审核成功！");
            this.deferVisible = false;
            this.query();
          })
        }
      })

    },
    addBox() {
      this.$refs.boxForm.validate(val =>{
        if(val){
          let condition = {
            OPER_TYPE: 0,
            "OT_BOX_SEND_MASTER": [
              {
                "VOUCHER_ID": this.orderForm.MASTER_ID,
                "TARGET_ID": this.$store.state.userInfo.COMPANY_ID,
                "CITY_ID": this.boxForm.CITY_ID,
                "D_CITY_ID": '',
                "GOODS_TYPE": this.orderForm.GOODS_TYPE,
                "GODDS_NAME": this.orderForm.GOODS_NAME,
                "ESTIM_DATE": this.orderForm.ESTIM_DATE,
                "MEMO": this.orderForm.MEMO,
                "SEND_SPACE_ID": this.boxForm.SEND_SPACE_ID,
                "SEND_SPACE_TYPE": 10000147,
                "SEND_SPACE_PERSON": this.boxForm.SEND_SPACE_PERSON,
                "SEND_SPACE_ADDRESS": this.boxForm.SEND_SPACE_ADDRESS
              }
            ],
            "OT_BOX_SEND_DETAIL": [
              {
                "ORGI_QTY": this.boxForm.ALREADY_BOX,
                "ORGI_PRICE": 1000,
                "VALID_PRICE": 1000,
                "PARENT_FLOW_ID": this.orderForm.MASTER_ID,
                "BOX_SIZE": this.orderForm.BOX_SIZE,
                "REAL_QTY": this.boxForm.ALREADY_BOX,
                "BEGIN_DATE": this.$moment(this.boxForm.BEGIN_DATE).format('YYYY-MM-DD'),
                "END_DATE": this.$moment(this.boxForm.END_DATE).format('YYYY-MM-DD')
              }
            ]
          }
          this.$h5Api({
            type: '4018',
            data: [condition]
          }).then(reData => {
            this.boxShow = false;
          }).catch(e => {
          })
        }
      })
    },
    cancelBox() {
      this.boxShow = false
    },
    addOrder() {
    },
    cancelOrder() {
    },
    getOrderDetail(MASTER_ID){
      this.$h5Api({
        type:'4025',
        data: [{
          "QUERY_TYPE": 1,
          "MASTER_ID": MASTER_ID,
        }],
      }).then(({data}) =>{
        this.orderForm = Object.assign({},data?.OT_XC_MASTER?.[0],data?.OT_XC_DETAIL?.[0]);
        let priceList = [];
        data.OT_XC_DETAIL.forEach(item =>{
          priceList.push(Object.assign({},data?.OT_XC_MASTER?.[0],item));
        })
        let reBoxOrderList = [];
        let xeMasterMap = {};
        data.OT_BOX_XE_MASTER.forEach(item =>{
          if(item.CHECK_STATUS === 1){
            xeMasterMap[item.MASTER_ID] = item;
          }
        })
        //data.OT_BOX_XE_MASTER
        data.OT_BOX_XE_DETAIL.forEach(item =>{
          if(xeMasterMap[item.MASTER_ID]){
            reBoxOrderList.push(Object.assign({},xeMasterMap[item.MASTER_ID],item));
          }
        })
        this.transportList = data.OT_SHEET_SHIP;
        this.reBoxOrderList = reBoxOrderList;
        this.priceList = priceList;
      })
    },
    editTransport(item){
      this.transportShow = true
    }
  },
  created() {
    if (this.$route.query.MASTER_ID) {
      this.getOrderDetail(this.$route.query.MASTER_ID);
    }
  }
}
</script>

<style lang="scss">
.order-details-page{
  flex: 1;
  margin-left: 24px;
  overflow-y: auto;
  max-height: 800px;

  .dol-list-style{
    .ant-card.ant-card-bordered{
      .ant-card-head{
        padding: 0;
      }
      .ant-card-body{
        padding: 0;
      }
    }
  }

  .order-details-title {
    display: flex;
    justify-content: space-between;
  }

  .order-info-title {
    font-size: 18px;
    font-weight: 600;
    color: #000000;
  }

  .order-details-descriptions {
    .order-details-info {
      font-size: 18px;
      font-weight: 600;
      color: #000000;
    }
  }

}

.takes-box-div {
  padding: 24px;
  width: 417px;
  border: 1px solid #CFCFCF;
  border-radius: 6px;
  margin: 10px;
}

.takes-detail {
  border: 1px solid #e8e8e8 !important;
  .takes-detail-title {
    display: flex;
    justify-content: space-between;
  }

  .takes-detail-content {
    justify-content: space-between;
    display: flex;
    flex-wrap: wrap;
    margin-top: 14px;
    margin-left: -10px;
    .takes-detail-content-box {
      padding: 14px;
      width: 396px;
      height: 138px;
      background: #1F6CBA;
      margin: 10px;
      border-radius: 6px;
      color: #FFFFFF;
      .takes-detail-content-box-title{
        display: flex;
        justify-content: space-between;
      }
      .takes-detail-content-box-info{
        display: flex;
        margin-top: 11px;
      }
      .takes-detail-content-box-num{
        margin-top: 16px;
      }
      .takes-detail-content-box-code{
        display: flex;
        flex-wrap: wrap;
        margin-left: -15px;
      }

    }
  }
}
.box-code-card{
  border: 1px solid #666666;
}

</style>